export var PaymentMethodTypes = /*#__PURE__*/ function(PaymentMethodTypes) {
    PaymentMethodTypes["BankAccount"] = "bankAccount";
    PaymentMethodTypes["PlaidBankAccount"] = "plaidBankAccount";
    PaymentMethodTypes["CreditCard"] = "creditCard";
    return PaymentMethodTypes;
}({});
export var BankAccountStatusTypes = /*#__PURE__*/ function(BankAccountStatusTypes) {
    /** Means it's unverified. Will be the status for new bank-accounts added by micro-deposit. */ BankAccountStatusTypes["New"] = "new";
    /** Verified. */ BankAccountStatusTypes["Validated"] = "validated";
    /** Verified. */ BankAccountStatusTypes["Verified"] = "verified";
    /** Failed verification once. */ BankAccountStatusTypes["VerificationFailed"] = "verification_failed";
    /** Failed verification twice. The UI should block a 3rd attempt as that attempt is irreversible. */ BankAccountStatusTypes["TwoAttemptsFailed"] = "twoAttemptsFailed";
    /** using plaid verification flow. See plaidVerificationStatus field for more details. */ BankAccountStatusTypes["PlaidVerification"] = "plaidVerification";
    /** using plaid verification flow. See plaidVerificationStatus field for more details. */ BankAccountStatusTypes["PlaidVerificationFailed"] = "plaidVerificationFailed";
    /** Stripe doesn't let us add this bank-account because its a duplicate bank-account. */ BankAccountStatusTypes["FailedDueToDuplicate"] = "failed_due_to_duplicate";
    /** A general error from Stripe when attempting to add the bank-account. */ BankAccountStatusTypes["Errored"] = "errored";
    return BankAccountStatusTypes;
}({});
export var PlaidBankAccountStatusTypes = /*#__PURE__*/ function(PlaidBankAccountStatusTypes) {
    PlaidBankAccountStatusTypes["PendingAutomaticVerification"] = "pending_automatic_verification";
    PlaidBankAccountStatusTypes["PendingManualVerification"] = "pending_manual_verification";
    PlaidBankAccountStatusTypes["AutomaticallyVerified"] = "automatically_verified";
    PlaidBankAccountStatusTypes["ManuallyVerified"] = "manually_verified";
    PlaidBankAccountStatusTypes["VerificationExpired"] = "verification_expired";
    PlaidBankAccountStatusTypes["VerificationFailed"] = "verification_failed";
    return PlaidBankAccountStatusTypes;
}({});
export var VerifyWithEnum = /*#__PURE__*/ function(VerifyWithEnum) {
    VerifyWithEnum["Plaid"] = "plaid";
    VerifyWithEnum["Stripe"] = "stripe";
    VerifyWithEnum["None"] = "none";
    return VerifyWithEnum;
}({});
